import Input from 'components/FormElements/Input/Input';
import NumberStepper from 'components/FormElements/NumberStepper/NumberStepper';
import Textarea from 'components/FormElements/Textarea/Textarea';
import Modal from 'components/Modal/Modal';
import { totalUpNumbers } from 'utils/numberUtils';
import useHomeQuickModal from "./useHomeQuickModal";
import './HomeQuickModal.scss';

const HomeQuickModal = ({ open, onClose }) => {
  const {
    submit,
    quickModalDetails,
    setQuickModalDetails,
  } = useHomeQuickModal({ onClose });

  return (
    <Modal
      className='home-quick-modal modal--large'
      show={open}
      onCancel={onClose}
      footer={
        <>
          <span className='action' onClick={() => onClose()}>Cancel</span>
          <span className='separator'></span>
          <span className='action' onClick={(e) => submit(e)}><strong>Save</strong></span>
        </>
      }
    >
      <div>
        <Textarea
          formGroupClassName='diet-notes'
          label='Diet / Calories:'
          value={quickModalDetails.dietNotes}
          onChange={(e) => setQuickModalDetails(prev => ({ ...prev, dietNotes: e.target.value }))}
          rows={12}
        />
        <p className='day-calories lit'>Calories: {totalUpNumbers(quickModalDetails.dietNotes)}</p>

        <div className='form-group form-group--two-column'>
          <Input
            id="exerciseHours"
            label="Exercise:"
            min={0}
            type='number'
            placeholder="Hours"
            value={quickModalDetails.exerciseHours}
            onChange={(e) => setQuickModalDetails(prev => ({ ...prev, exerciseHours: e.target.value }))}
          />
          <Input
            type='number'
            id="exerciseMinutes"
            placeholder="Minutes"
            min={0}
            max={59}
            value={quickModalDetails.exerciseMinutes}
            onChange={(e) => setQuickModalDetails(prev => ({ ...prev, exerciseMinutes: e.target.value }))}
          />
        </div>
       
        <Textarea
          label='Exercise Notes:'
          value={quickModalDetails.exerciseNotes}
          onChange={(e) => setQuickModalDetails(prev => ({ ...prev, exerciseNotes: e.target.value }))}
          rows={5}
        />

        <NumberStepper
          formGroupClassName='meditation'
          id="meditation"
          label="Meditation:"
          min={0}
          value={quickModalDetails.meditation}
          onChange={(e) => setQuickModalDetails(prev => ({ ...prev, meditation: e.target.value }))}
        />

      </div>
    </Modal>
  );
};

export default HomeQuickModal;